import * as React from 'react'
import { ModalLayoutConnected } from './ModalLayoutConnected'
import { Provider } from 'react-redux'
import { mockState, createMockStore } from 'mockState'

export const ModalLayoutExamples = () => {
  return (
    <div className="ModalLayoutExamples exampleContainer">
      <h1 className="exampleHeader">default</h1>

      <Provider store={createMockStore(mockState)}>
        <ModalLayoutConnected />
      </Provider>
    </div>
  )
}
